;(function ($) {
    $.fn.naturataParallaxSideelements = function () {
        return $(this).each(function () {
            var sideelement = $(this);
			var initialTop = parseInt(sideelement.css('top'));
			var initialOffsetTop = sideelement.offset().top;

			$(window).on('load scroll', function () {
			    var newTopPosition = $(this).scrollTop() / initialOffsetTop * 50 + initialTop;

			    sideelement.css({
					'top' : newTopPosition+"px"
				});
			});

        });
    };
    $(function () {
        $('[data-parallax-sideelement]').naturataParallaxSideelements();
    });
})(jQuery);
